import { isObject } from "../../../common/tools";
import type { StateManaged } from "./state.types.js";
import { NAV_META, NAV_SCOPES } from "../lib/utils.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const sanitizeState = (state: unknown, scoped: boolean): StateManaged => {
  /*                                                                       */
  const stateObject = { ...(isObject(state) ? (state as Partial<StateManaged>) : {}) };

  /*                                                                   */
  /*                                                        */
  /*                                                                       */
  stateObject[NAV_META] = scoped ? { ...stateObject[NAV_META] } : {};
  stateObject[NAV_SCOPES] = scoped ? { ...stateObject[NAV_SCOPES] } : {};

  return stateObject as StateManaged;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const sanitizeIncommingState = (
  isContext: boolean,
  current: unknown,
  next: unknown,
  clean: boolean | undefined,
): StateManaged => {
  /*                                       */
  const result = sanitizeState(next, isContext);

  /*                                            */
  if (clean) return result;

  /*                                                                      */
  /*                                                          */
  const cur = sanitizeState(current, true);
  result[NAV_META] = Object.assign(cur[NAV_META], result[NAV_META]);
  result[NAV_SCOPES] = Object.assign(cur[NAV_SCOPES], result[NAV_SCOPES]);

  return result;
};
